var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('homer-slider'),_c('gpb-usd-phone'),_c('advantage-phone'),_c('footer-slider-phone'),_c('start-slider-phone'),_c('contact-us-phone')],1)}
var staticRenderFns = []

export { render, staticRenderFns }